<template>
  <section v-if="delegation" class="TcCalendar">
    <div>
      <h2 class="text-3xl text-center font-bold my-10">{{ delegation.name }}</h2>
      <h3 class="text-4xl text-center uppercase">{{ monthAndYear }}</h3>
      <ul class="text-center hidden">
        <li v-for="room in rooms" :key="room.id">{{ room.room_name }}</li>
      </ul>
      <div v-if="selected_room" class="container px-5 mx-auto mt-8">
        <div class="flex items-center">
          <div class="flex-shrink">
            <div @click="prevWeek()" v-if="prevWeekVisible"
              class="bg-gray-300 rounded-full p-4 hover:bg-gray-400 text-white cursor-pointer select-none">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
              </svg>
            </div>
            <div v-else class="p-4"><div class="h-16 w-16"></div></div>
          </div>
          <div class="flex-1" v-for="w in week" :key="w.id">
            <tc-calendar-day :date="w" :room="selected_room"></tc-calendar-day>
          </div>
          <div class="flex-shrink">
            <div @click="nextWeek()"
              class="bg-gray-300 rounded-full p-4 hover:bg-gray-400 text-white cursor-pointer select-none">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <tc-appointment-form v-if="creatingAppointment"
      :delegation="delegation"
      :time_slot="selected_slot"
    ></tc-appointment-form>
  </section>
</template>

<script>
import TcCalendarDay from './TcCalendarDay.vue';
import TcAppointmentForm from './TcAppointmentForm.vue';
export default {
  name: 'TcCalendar',
  components: {
    TcCalendarDay,
    TcAppointmentForm,
  },
  data () {
    return {
      delegation: null,
      rooms: [],
      selected_room: null,
      slots: [],
      selected_slot: null,
      start_date: this.$root.today.getMonday(),
      ndays: 5,
      week: [],
      creatingAppointment: false,
    }
  },
  created() {
    //console.log('CREATED DELEG', this.$root.selected_delegation);
    this.$root.loadDelegations().then(r => {
      //console.log('AFTER TOOD', this);
      this.delegation = this.$root.selected_delegation || this.$root.delegations[0];
      this.loadRooms();
    })
    this.setWeek();
  },
  computed: {
    prevWeekVisible: function () {
      //console.log('TODAY', this.$root.today.getMonday().toIsoDateStr())
      //console.log('START', this.start_date.toIsoDateStr())
      return this.start_date.toIsoDateStr() > this.$root.today.getMonday().toIsoDateStr()
    },
    monthAndYear: function() {
      return this.start_date.toLocaleString('es-ES',{ month: 'long' }) + ' '+ this.start_date.getFullYear();
    },
  },
  methods: {
    nextWeek: function() {
      this.start_date = this.start_date.nextWeek();
      this.setWeek();
      this.loadCalendar();
    },
    prevWeek: function() {
      this.start_date = this.start_date.prevWeek();
      this.setWeek();
      this.loadCalendar();
    },
    setWeek: function() {
      var _t = this.start_date.getTime();
      var _f = 86400000;
      this.week = [...Array(this.ndays).keys()].map(w => {
        return {
          id: w,
          date: new Date( _t + w * _f ),
          slots: null,
        }
      });
    },
    loadCalendar: function() {
      // calcular los slots vacíos para toda la semana
      var slots= new Array();
      let start_h = new Date(this.selected_room.date_start);
      let end_h = new Date(this.selected_room.date_start);
      let h = this.selected_room.hour_start.split(':')
      let duration = this.selected_room.duration
      start_h.setHours(parseInt(h[0]), parseInt(h[1]), 0, 0)
      h = this.selected_room.hour_end.split(':')
      end_h.setHours(parseInt(h[0]), parseInt(h[1]), 0, 0)
      //console.log('S',start_h,end_h)
      //console.log('SLOTS VACIOS', slots);
      while(start_h<=end_h) {
        slots.push({time: start_h.toIsoTimeStr(), active: false})
        start_h.setHours(start_h.getHours(), start_h.getMinutes() + duration)
      }
      this.week.forEach(w => {
        //console.log('W',w)
        w.slots = slots.map(s => {
          return  Object.assign({id: Math.random() * 100, date: w.date}, s)
        })
      })

      let end_date = new Date(this.start_date)
      end_date.setDate(end_date.getDate() + 4)
      let url = '/get.php?' + objToParams({
        action: 'apicalendar',
        access_token: this.$root.access_token,
        room_id: this.selected_room.id,
        start_date: this.start_date.toIsoDateStr(),
        end_date: end_date.toIsoDateStr(),
      });
      //console.log('loadCalendar URL', url);
      return fetch(url).then(response =>response.json()).then(json => {
        //console.log('SLOTS', json);
        json.forEach(slot => {
          var d = new Date(slot.start);
          var time = slot.start.slice(-8,-3);
          //console.log('SLOT - TIME', slot.start, time);
          var weekdayindex = d.getDay() - 1;
          if(weekdayindex<0) weekdayindex = 6; // el domingo
          this.week[weekdayindex].slots.forEach(_s => {
            if(_s.time==time) {
              _s.active = true;
            }
          })
          //console.log('SLOT', weekdayindex, time);
        })
      }).catch(err => {
        console.error('Se ha producido un error', err);
      });
    },
    setSelectedRoom: function(room) {
      this.selected_room = room;
      if(room && room.id) {
        this.loadCalendar()
      }
    },
    loadRooms: function() {
      let url = '/get.php?' + objToParams({
        action: 'get_rooms_delegation',
        access_token: this.$root.access_token,
        delegation_id: this.delegation.id,
      });
      //console.log('URL', url);
      return fetch(url).then(response =>response.json()).then(json => {
        //console.log('ROOMS', json);
        //json.forEach(r => {})
        this.rooms = json;
        if(this.rooms.length>0) {
          this.setSelectedRoom(this.rooms[0]);
        } else {
          this.setSelectedRoom(null);
        }
      }).catch(err => {
        console.error('Se ha producido un error', err);
      });
    }
  }
}
</script>